var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueColorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_22216_24146_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00910227 0.0154432 -0.0154432 0.00910227 31 31)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1451.29,
    y: -1451.29,
    width: 2902.59,
    height: 2902.59
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 0, 0, 1) 0deg,rgba(255, 152, 0, 1) 65.625deg,rgba(35, 255, 0, 1) 136.875deg,rgba(0, 193, 255, 1) 217.5deg,rgba(173, 0, 255, 1) 290.625deg,rgba(255, 0, 0, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 43.2727C37.778 43.2727 43.2727 37.778 43.2727 31C43.2727 24.222 37.778 18.7273 31 18.7273C24.222 18.7273 18.7273 24.222 18.7273 31C18.7273 37.778 24.222 43.2727 31 43.2727ZM31 49C40.9411 49 49 40.9411 49 31C49 21.0589 40.9411 13 31 13C21.0589 13 13 21.0589 13 31C13 40.9411 21.0589 49 31 49Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.59999990463256836,\"b\":0.0,\"a\":1.0},\"position\":0.18229167163372040},{\"color\":{\"r\":0.13999998569488525,\"g\":1.0,\"b\":0.0,\"a\":1.0},\"position\":0.38020834326744080},{\"color\":{\"r\":0.0,\"g\":0.75999975204467773,\"b\":1.0,\"a\":1.0},\"position\":0.60416668653488159},{\"color\":{\"r\":0.67999982833862305,\"g\":0.0,\"b\":1.0,\"a\":1.0},\"position\":0.80729168653488159},{\"color\":{\"r\":1.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.59999990463256836,\"b\":0.0,\"a\":1.0},\"position\":0.18229167163372040},{\"color\":{\"r\":0.13999998569488525,\"g\":1.0,\"b\":0.0,\"a\":1.0},\"position\":0.38020834326744080},{\"color\":{\"r\":0.0,\"g\":0.75999975204467773,\"b\":1.0,\"a\":1.0},\"position\":0.60416668653488159},{\"color\":{\"r\":0.67999982833862305,\"g\":0.0,\"b\":1.0,\"a\":1.0},\"position\":0.80729168653488159},{\"color\":{\"r\":1.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":18.204545974731445,\"m01\":-30.886362075805664,\"m02\":37.340908050537109,\"m10\":30.886362075805664,\"m11\":18.204545974731445,\"m12\":6.4545469284057617},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_22216_24146_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 43.2727C37.778 43.2727 43.2727 37.778 43.2727 31C43.2727 24.222 37.778 18.7273 31 18.7273C24.222 18.7273 18.7273 24.222 18.7273 31C18.7273 37.778 24.222 43.2727 31 43.2727ZM31 49C40.9411 49 49 40.9411 49 31C49 21.0589 40.9411 13 31 13C21.0589 13 13 21.0589 13 31C13 40.9411 21.0589 49 31 49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueColorActive);
export default __webpack_public_path__ + "static/media/true-color-active.0df3b6f4c07160183eabf565b1e0aec0.svg";
export { ForwardRef as ReactComponent };